<template>
	<div class="pinnacle" style="height:100%">
		<div class="contern">
			<div class="menu row-center" style="justify-content:space-between">
				<div class="row-center">
					<span style="font-size:18rem">选择日期：</span>
					<el-date-picker :editable="false" :picker-options="pickerOptions" style="height: 40px !important"
									:clearable="false" class="dateSelect" v-model="date"
									:type="radio === 'day' ? 'date' : radio"
									:placeholder="new Date().toLocaleDateString().replace(/\//g, '-')">
					</el-date-picker>

					<div class="radio">
						<el-radio v-model="radio" label="year"
								v-if="routeName === 'Pinnacle' || routeName === 'Comparison' ">
							年
						</el-radio>
						<el-radio v-model="radio" label="month">月</el-radio>
						<el-radio v-model="radio" label="day" v-if="routeName !== 'Pinnacle'">日</el-radio>
					</div>
					<div class="btn per" @click="perD" v-if="radio === 'day'">上一日</div>
					<div class="btn per" @click="perM" v-if="radio === 'month'">上一月</div>
					<div class="btn per" @click="perY" v-if="radio === 'year'">上一年</div>
					<el-button class="btn next" plain @click="nextD" v-if="radio === 'day'" :disabled="nextDayDisabled">
						下一日
					</el-button>
					<el-button class="btn next" plain @click="nextM" v-if="radio === 'month'"
							:disabled="nextDayDisabled">
						下一月
					</el-button>
					<el-button class="btn next" plain @click="nextY" v-if="radio === 'year'"
							:disabled="nextDayDisabled">下一年
					</el-button>
				</div>
			</div>
			<div class="charts">
				<div class="chartsleft" style="width: 70%;height: 100%;">
					<charts id="PinnacleCharts2" :option="PinnacleOptionBar"></charts>
				</div>
				<div class="chartsright" style="width: 30%;height: 100%;">
					<charts id="PinnacleCharts" :option="PinnacleOption"></charts>
				</div>
			</div>
		</div>
		
		<div class="footer">
			<div class="tit">尖峰平谷数据</div>
			<div class="info row-center">
				<div class="item">
					<div class="title txt">总电量(kWh)：</div>
					<div class="content">
						<div class="row">
							<div class="k txt"></div>
							<div class="v txt"
								style="font-size: 36px;color: rgba(13, 148, 255, 1);font-weight: bold;">{{pinnacleInfo.total}}
							</div>
						</div>
					</div>
				</div>
				<div class="item">
					<div class="title txt">尖电量：</div>
					<div class="content">
						<div class="row">
							<span class="k txt">电量(kWh):</span>
							<span class="v txt">{{pinnacleInfo.sum_tip}}</span>
						</div>
						<div class="row">
							<span class="k txt">电量占比(%):</span>
							<span class="v txt">{{pinnacleInfo.percentage_tip}}</span>
						</div>

					</div>
				</div>
				<div class="item">
					<div class="title txt">峰电量：</div>
					<div class="content">
						<div class="row">
							<span class="k txt">电量(kWh):</span>
							<span class="v txt">{{pinnacleInfo.sum_peak}}</span>
						</div>
						<div class="row">
							<span class="k txt">电量占比(%):</span>
							<span class="v txt">{{pinnacleInfo.percentage_peak}}</span>
						</div>

					</div>
				</div>
				<div class="item">
					<div class="title txt">平电量：</div>
					<div class="content">
						<div class="row">
							<span class="k txt">电量(kWh):</span>
							<span class="v txt">{{pinnacleInfo.sum_level}}</span>
						</div>
						<div class="row">
							<span class="k txt">电量占比(%):</span>
							<span class="v txt">{{pinnacleInfo.percentage_level}}</span>
						</div>

					</div>
				</div>
				<div class="item">
					<div class="title txt">谷电量：</div>
					<div class="content">
						<div class="row">
							<span class="k txt">电量(kWh):</span>
							<span class="v txt">{{pinnacleInfo.sum_valley}}</span>
						</div>
						<div class="row">
							<span class="k txt">电量占比(%):</span>
							<span class="v txt">{{pinnacleInfo.percentage_valley}}</span>
						</div>

					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Curve from "../../chart/Curve";
	import charts from "../../components/Energy/charts";
	import {
		POWER_ANALYSIS_BY_LOOP
	} from "../../api/power";
	import Extremum from "./report/Extremum";
	import Running from "./report/Running";
	import PinnacleTable from "./sheet/PinnacleTable.vue";
	import {
		floatFormat
	} from "../../util/MathUtil";
	import {
		perDay,
		perMonth,
		perYear,
		nextDay,
		nextMonth,
		nextYear,
		dateFormat,
		dayStart,
		dayEnd,
		monthDays
	} from "../../util/DateUtil";
	import CircuitBreakerAging from "./CircuitBreakerAging";
	import PowerTime from "./report/PowerTime";
	import PowerRange from "./report/PowerRange";
	import {
		storeInstance
	} from "../../main";

	export default {
		name: "PowerDataBase",
		props: {
			realData: Array,
			options: Array,
			currentLoop: Object,
			selectedLoops: Array,
		},
		components: {
			Curve,
			Extremum,
			Running,
			CircuitBreakerAging,
			PowerTime,
			PowerRange,
			PinnacleTable,
			charts
		},
		data() {
			let that = this
			return {
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					},
				},
				radio: "day",
				date: new Date(),
				xmonth:[],
				seriesData:[{data:[]},{data:[]},{data:[]},{data:[]}],
				barData:[],
				pinnacleInfo:{}
			};
		},
		computed: {
			PinnacleOptionBar(){
				return {
					color: ["#5B8FF9", "#5AD8A6", "#5D7092", "#F6BD16","E8684A","6DC8EC","9270CA","FF9D4D","269A99","FF99C3"],
					tooltip: {
						trigger: 'axis',
						axisPointer: {            // 坐标轴指示器，坐标轴触发有效
							type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
						}
					},
					legend: {
            			icon: "rect",
						itemWidth: 10,
            			itemHeight: 10,
						textStyle: {
							fontSize: 15,
						},
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					xAxis: [
						{
							type: 'category',
							data: this.xmonth,
							axisTick: {
								alignWithLabel: true
							}
						}
					],
					yAxis: {
						type: "value",
						name: "kWh",
					},
					series:  [
					
						{
							name: '尖',
							type: 'bar',
							stack: '1',
							// barWidth : 15,
							data: this.seriesData[0].data
						},
						{
							name: '峰',
							type: 'bar',
							stack: '1',
							// barWidth : 15,
							data: this.seriesData[1].data
						},
						{
							name: '平',
							type: 'bar',
							stack: '1',
							// barWidth : 15,
							data: this.seriesData[2].data
						},
						{
							name: '谷',
							type: 'bar',
							stack: '1',
							// barWidth : 15,
							data: this.seriesData[3].data
						},
					]
					 
				};
			},
			PinnacleOption() {
				return {
					color: ["#5B8FF9", "#5AD8A6", "#5D7092", "#F6BD16","E8684A","6DC8EC","9270CA","FF9D4D","269A99","FF99C3"],
					tooltip: {
						trigger: "item",
					},
					
					graphic:{       //图形中间文字
						type:"text",
						left:"center",
						top:"center",
						style:{
							text:"尖峰平谷\n占比",
							textAlign:"center",
							fontSize: "16rem",
							lineHeight: 30,
							fontWeight: 800,
						}
					},
					series: [
						{
							// name: "访问来源",
							type: "pie",
							radius: ["25%", "45%"],
							label: {
								show:true,
								// normal: {
								// 	show: true,
								// 	position: "center",
								// 	formatter: "{name|尖峰平谷\n占比}",
								// 	rich: {
								// 		name: {
								// 		color: "#333333",
								// 			fontSize: 16,
								// 			lineHeight: 30,
								// 			fontWeight: 800,
								// 		},
								// 	},
								// },
								formatter: "{name|{b}}\n{time|{d}%}",
								minMargin: 5,
								edgeDistance: 10,
								lineHeight: 25,
								fontSize: 18,
								fontWeight: 800,
								rich: {
									time: {
										fontSize: 16,
										color: "#0D94FF",
									},
								},
							},
							itemStyle: { // 此配置
								normal: {
									borderWidth: 1,
									borderColor: '#ffffff',
								},
							},
							labelLine: {
								// length: 30,
								// length2: 100,
								show: true,
								lineStyle:{
									width:2
								}
								// color: "#00ffff",
							},
							data: this.barData 
						}
					],
				};
				},
			routeNameAndTag() {
				return [this.routeName, this.tag];
			},
			//路由名称
			routeName() {
				return this.$route.params.name;
			},
			//路由tag
			tag() {
				return this.$route.params.tag;
			},

			nextDayDisabled() {
				let timestamp = dateFormat("YY-mm-dd", new Date());
				let endtime = dateFormat("YY-mm-dd", this.date);
				if (this.radio === "year") {
					timestamp = dateFormat("YY", new Date());
					endtime = dateFormat("YY", this.date);
				} else if (this.radio === "month") {
					timestamp = dateFormat("YY-mm", new Date());
					endtime = dateFormat("YY-mm", this.date);
				}
				if (endtime >= timestamp) {
					return true;
				} else {
					return false;
				}
			},
			propsData() {
				return [
					this.radio,
					this.date,
					this.currentLoop
				]
			}
		},
		created() {

		},
		mounted() {
			let _this = this
			_this.nextDayDisabled;
			_this.initPowerTimeData();
			
		},
		watch: {
			propsData(n) {
				if(this.currentLoop){
					this.requestData()
				}
			},
			radio(n) {
				this.date = new Date();
				// 	this.xmonth = []
				// if(this.radio === 'month'){
				// 	for(let i = 0; i <= 31; i++){
				// 		this.xmonth.push(i+'日')
				// 	}
				// }else{
				// 	for(let i = 0; i <= 12; i++){
				// 		this.xmonth.push(i+'日')
				// 	}	
				// }
			},

			tag(n, o) {
				this.initPowerTimeData();
			},
			routeName(n) {
				if (n == "Pinnacle") {
					this.radio = "month";
				}

			}
		},
		methods: {
			async requestData() {
				let res = await POWER_ANALYSIS_BY_LOOP(this.date, this.radio, this.currentLoop.loopId)
				try {
					let resData = res.data.data.result
					if (resData) {
						let year = 'year_' + this.date.getFullYear()
						let month = 'month_' + (this.date.getMonth() + 1)
						this.barData =[
							{ value: resData.sum_tip?resData.sum_tip.toFixed(2):"--", name: "尖" },
							{ value: resData.sum_peak?resData.sum_peak.toFixed(2):"--", name: "峰" },
							{ value: resData.sum_level?resData.sum_level.toFixed(2):"--", name: "平" },
							{ value: resData.sum_valley?resData.sum_valley.toFixed(2):"--", name: "谷" },
						]
						this.pinnacleInfo = {
							percentage_level: resData.percentage_level?floatFormat(resData.percentage_level * 100, 2):"--",
							percentage_peak: resData.percentage_peak?floatFormat(resData.percentage_peak * 100, 2):"--",
							percentage_tip: resData.percentage_tip?floatFormat(resData.percentage_tip * 100, 2):"--",
							percentage_valley: resData.percentage_valley?floatFormat(resData.percentage_valley * 100, 2):"--",
							sum_level: resData.sum_level?resData.sum_level.toFixed(2):"--",
							sum_peak: resData.sum_peak?resData.sum_peak.toFixed(2):"--",
							sum_tip: resData.sum_tip?resData.sum_tip.toFixed(2):"--",
							sum_valley: resData.sum_valley?resData.sum_valley.toFixed(2):"--",
							total: resData.total?resData.total.toFixed(2):"--"
						}
						if (this.radio === 'month') {
							let monthData = resData[year][month]
							let data1=[],data2=[],data3=[],data4=[];
							for (let j = 1; j <= monthDays(this.date); j++) {
								let dayData = monthData['day_' + j]
								if (dayData) {
									data1.push(dayData.sum_tip?dayData.sum_tip.toFixed(2):0)  //尖
									data2.push(dayData.sum_peak?dayData.sum_peak.toFixed(2):0)  //峰
									data3.push(dayData.sum_level?dayData.sum_level.toFixed(2):0)  //平
									data4.push(dayData.sum_valley?dayData.sum_valley.toFixed(2):0)  //谷
								}else{
									data1.push("")
									data2.push("")
									data3.push("")
									data4.push("")
								}
							}
							this.xmonth = []
							for(let i = 0; i <= 30; i++){
								this.xmonth.push(i+1+'日')
							}
							this.seriesData = [{data:data1},{data:data2},{data:data3},{data:data4}]
						} else {
							// 年的
							let yearData = resData[year]
							let data1=[],data2=[],data3=[],data4=[];
									this.xmonth = []
							for (let j = 1; j <= 12; j++) {
								this.xmonth.push(j+'月')
								let monthData = yearData['month_' + j]
								if (monthData) {
									data1.push(monthData.sum_tip?monthData.sum_tip.toFixed(2):0)  //尖
									data2.push(monthData.sum_peak?monthData.sum_peak.toFixed(2):0)  //峰
									data3.push(monthData.sum_level?monthData.sum_level.toFixed(2):0)  //平
									data4.push(monthData.sum_valley?monthData.sum_valley.toFixed(2):0)  //谷
								}else{
									data1.push("")
									data2.push("")
									data3.push("")
									data4.push("")
								}
							}
							this.seriesData = [{data:data1},{data:data2},{data:data3},{data:data4}]
						}

					} 
				} catch (e) {
					this.barData =[
						{ value: 0, name: "尖" },
						{ value: 0, name: "峰" },
						{ value: 0, name: "平" },
						{ value: 0, name: "谷" },
					]
					this.pinnacleInfo = {
						percentage_level: "--",
						percentage_peak:  "--",
						percentage_tip:  "--",
						percentage_valley:  "--",
						sum_level:  "--",
						sum_peak:  "--",
						sum_tip:  "--",
						sum_valley:  "--",
						total: "--"
					}
					let data1=[0],data2=[0],data3=[0],data4=[0];
					this.seriesData = [{data:data1},{data:data2},{data:data3},{data:data4}]
				}
			},
			initPowerTimeData() {
				if (this.routeName === "Pinnacle") {
					this.radio = "month";
				} else {
					this.allNodeData = [];
				}
			},
			perD() {
				this.date = perDay(this.date);
			},
			nextD() {
				this.date = nextDay(this.date);
			},
			perM() {
				this.date = perMonth(this.date);
			},
			nextM() {
				this.date = nextMonth(this.date);
			},
			perY() {
				this.date = perYear(this.date);
			},
			nextY() {
				this.date = nextYear(this.date);
			},

		},
	};
</script>

<style scoped lang="less">
	.pinnacle{
		height: 100%;
		font-size: 18rem;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		.contern{
			background: #ffffff;
			height: 67vh;
			padding: 20rem;
		}
		.charts {
			display: flex;
			flex-flow: row wrap;
			justify-content: space-between;
			align-items: center;
			height: 52vh;
			margin-top: 70rem;
		}
	}
	.footer {
		background: #ffffff;
		height: 21vh;
		.info {
            padding:25px 24px 10px 24px;
            align-items: flex-start;
			.item {
				width: 20%;

                .row {
                    margin-bottom: 15rem;
                }

				.k {
					margin-right: 9px;
				}

				.v {
					color: rgba(13, 148, 255, 1) !important;
				}

				.txt {
					font-size: 18rem;
					font-weight: 400;
					color: #333333;
				}

				.title {
					margin-bottom: 15rem;

				}
			}
		}

		.tit {
			height: 57rem;
			font-size: 18rem;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #333333;
			line-height: 57rem;
			border-bottom: 1px solid rgba(0, 0, 0, .15);
			padding: 0 25px;
		}
	}

	.tit-com {
		font-size: 18px;
		font-weight: 400;
		color: #333333;

		border-left: 4px solid rgba(13, 148, 255, 1);
		height: 24px;
		line-height: 24px;
		padding-left: 17px;
	}

	.radio-3 {
		span {
			font-size: 18px;
			font-weight: 400;
			color: #333333;
		}

		div {
			width: 33.33%;
			height: 33px;
			line-height: 33px;
			text-align: center;
			font-size: 18px;
			font-weight: 400;
			color: #333333;
			border: 1px solid rgba(51, 51, 51, .15);
			cursor: pointer;

			&:hover, &.active {
				color: rgba(13, 148, 255, 1);
				border: 1px solid rgba(13, 148, 255, 1);
			}
		}
	}

	.loadfactor {
		width: 120rem;
		text-align: center;
	}

	.el-dropdown-menu__item.active {
		color: #0d94ff;
	}

	.alarming {
		// color: #fd4238 !important;
	}

	.breaker-data-1 {
		.h(968) !important;
	}

	.tab-breaker {
		> div {
			font-size: 18rem;
			font-weight: 400;
			color: #999999;
			border-top: 2px solid #ffffff;
			padding-top: 23rem;
			margin-right: 25rem;

			&.active {
				font-weight: bold;
				color: #0d94ff;
				border-top: 2px solid rgba(13, 148, 255, 1);
			}
		}
	}

	.transformerClass {
		.h(570) !important;

		.echarts {
			.left {
				.h(400) !important;
			}
		}

		.max-right {
			.h(400) !important;
		}
	}

	.transformer-data {
		padding: 0 24rem;
		background-color: #fff;
		.h(389);

		.card-list {
			.card-item {
				.w(298);
				.h(254);
				padding: 0rem 24rem;
				border-radius: 4px;
				background-color: rgba(0, 43, 102, 0.04);
				position: relative;

				h5 {
					font-size: 18rem;
					font-weight: 400;
					color: #333333;
				}

				span {
					font-size: 24rem;
					font-weight: bold;
					color: #0d94ff;
					// margin-top: 8rem;
				}

				.val-details {
					width: 100%;
					justify-content: space-between;
					// margin-top: 20rem;

					span {
						font-size: 16rem;
						font-weight: 400;
						color: #999999 !important;
					}
				}
			}

			.type-2 {

				// padding-top: 70rem;
				span {
					margin-top: 25rem;
				}
			}

			.type-3 {
				align-items: flex-start;
				padding: 0 20rem;

				h4 {
					font-size: 24px;
					font-weight: bold;
					color: #f5aa00;
				}

				h5.sub-title {
					font-size: 17rem;
					color: rgba(51, 51, 51, 1);
					font-weight: bold;
				}

				p {
					font-size: 14rem;
					color: rgba(153, 153, 153, 1);
				}

				h5,
				p {
					line-height: 32rem;
				}
			}

			.type-4 {
				// padding-bottom: 12px;

				.other {
					span {
						font-size: 16rem;
						font-weight: 400;
						color: #999999;
					}
				}
			}

			.type-1 .column-center,
			.type-4 .column-center {
				height: 90rem;
				// width: 100%;
			}

			.type-1 .column-center:first-child,
			.type-4 .column-center:first-child {
				// height: 135rem;
				// padding-top: 20rem;
				// justify-content: initial;
				// width: 100%;
			}

			.other {
				position: absolute;
				bottom: 12rem;
			}
		}

		.tab {
			span {
				display: inline-block;

				min-width: 88rem;
				line-height: 64rem;
				border-top: 2px solid #ffffff;
				font-size: 18rem;
				text-align: center;
				margin-right: 29rem;
				transition: all 0.3s;
				font-weight: 400;
				color: #999999;

				&.active {
					border-top: 2px solid rgba(13, 148, 255, 1);
					color: #0d94ff;
					font-weight: bold;
				}
			}
		}
	}

	.tree {
		width: 100%;
		background-color: #fff;
		transition: all 0.5s;
		overflow: hidden;
		box-shadow: 0 0 2px 0 #8c939d;

		.data {
			width: 100%;
			margin-top: 8rem;
			height: 100%;
		}

		.option {
			width: 100%;
			.h(40);
			border-bottom: 1px solid rgba(0, 0, 0, 0.06);
			padding: 0 16rem;
			font-size: 14rem;
			font-weight: 300;
			color: #333333;
			line-height: 36rem;

			.all {
				cursor: pointer;

				img {
					// width: 16rem;
					// height: 16rem;
					margin-right: 8rem;
				}

				span {
					&:hover {
						color: rgba(13, 148, 255, 1);
					}
				}
			}

			> span {
				cursor: pointer;
				color: rgba(13, 148, 255, 1);
			}
		}
	}

	.nodes-tree {
		.w(260);
		height: 40px;
		margin-right: 8rem;
		background-color: #ffffff;
	}

	.report {
		margin-top: 24rem;
		.h(815);
	}

	.export {
		margin-left: 23rem;

		img {
			margin-right: 7rem;
		}

		span {
			font-size: 18rem;
			font-weight: 500;
			color: #333333;
		}
	}

	.btn {
		.w(96);
		height: 40px;
		line-height: 40px;
		text-align: center;
		font-size: 18px;
		font-weight: 400;
		color: #ffffff;
		background-color: #0d94ff;
		cursor: pointer;
		border-radius: 4rem;
		overflow: hidden;
		padding: 0px;
	}

	.per,
	.next {
		background-color: #fff;
		font-size: 18rem;
		color: #666666;
		font-weight: 400;
		border: 1px solid rgba(0, 0, 0, 0.15);

		&:hover {
			background-color: #0d94ff;
			color: #ffffff;
		}
	}

	.el-button.is-plain:hover {
		background-color: #0d94ff !important;
		color: #ffffff !important;
		transition: 0s;
	}

	.el-button.is-active,
	.el-button.is-plain:active,
	.el-button.is-plain:focus {
		background-color: #fff;
		border: 1px solid rgba(0, 0, 0, 0.15);
		color: #666666;
	}

	.el-button.is-disabled:hover {
		background-color: #ffffff !important;
		color: #c0c4cc !important;
		transition: 0s;
	}

	.per {
		// margin-left: 24rem;
	}

	.next {
		margin-left: 8rem;
	}

	.node-select,
	.dateSelect {
		.w(260) !important;
		// .h(40) !important;
	}

	.node-select {
		margin-right: 24rem;
	}
	
	.pinnacle {
		// padding: 24rem;
		// background-color: #fff;
		// .w(1265);
		// .h(968);

		.menu {
			// margin-top: 24rem;

			.export {
				margin-left: 61rem;
			}

			.radio {
				margin-left: 24rem;

				.el-radio {
					margin-right: 20rem;
				}
			}
		}

		.title {
			font-size: 18rem;
			font-weight: bold;
			color: #333333;
		}
	}

	.diagram {
		.w(1265);
		.h(618);
		margin-top: 8rem;
		background-color: #fff;
		padding-left: 24rem;

		// display: flex;
		.exetext {
			.w(728);
			display: flex;
			align-items: center;
			justify-content: space-between;

			.exetext1 {
				display: flex;
				align-items: center;
			}
		}

		.left {
			width: 100%;
			.h(480);
		}

		.echarts {
			width: 100%;

			.left {
				width: 100%;
				.h(460);
			}

			.max-right {
				.w(272);
				// height: 380px;
				.h(460);
				margin-right: 24rem;

				.row-max {
					width: 100%;
					background-color: rgba(0, 43, 102, 0.02);
					// height: 88px;
					margin-bottom: 10px;

					.details {
						.w(176);
						height: 100%;
						padding: 12rem 0;

						span {
							margin-right: 8rem;
							color: rgba(13, 148, 255, 1);
							font-size: 16rem;

							&:first-child {
								color: #333333;
							}
						}
					}

					.max-name {
						height: 100%;
						.w(96);
						font-size: 18rem;
						font-weight: bold;
						color: #333333;
					}
				}
			}
		}

		.showMax {
			div.left {
				.w(920) !important;
			}
		}

		.tab {
			width: 100%;
			.h(438);
			margin-top: 25rem;
		}

		.content {
			margin-top: 10rem;

			.dateSelect {
				font-size: 18rem;
				color: #000000 !important;
				margin-right: 8rem;
			}

			.max {
				.w(100);
				margin-left: 127rem;
			}

			.hose {
				display: flex;
				align-items: center;
			}
		}

		.select1 {
			margin-right: 27rem;
			font-size: 18rem;
			font-weight: 400;
			color: #333333;
			padding-top: 23rem;
			border-top: 2rem solid rgba(0, 0, 0, 0);
		}

		.select {
			> div {
				cursor: pointer;
				margin-right: 27rem;
				font-size: 18rem;
				font-weight: 400;
				color: #999999;
				padding-top: 21rem;
				border-top: 2rem solid rgba(0, 0, 0, 0);

				&.active {
					color: #0d94ff;
					font-weight: bold;
					border-top: 2rem solid #0d94ff;
				}
			}
		}
	}

	.real-data1 {
		.realLeft {
			padding: 24rem;
			.w(524);
			.h(342);
			background: #ffffff;
			box-shadow: 0px 0px 16px 0px rgba(0, 43, 102, 0.04);

			.status {
				width: 100%;
				.h(220);
				margin-top: 57rem;
				background-color: #fff;
				display: flex;
				justify-content: space-between;
			}

			.operation {
				.w(232);
				height: 100%;
				background: rgba(0, 43, 102, 0.04);
				display: flex;
				justify-content: center;
				align-items: center;

				.ovall {
					.h(127);
					.w(71);
					display: grid;
					text-align: center;

					.totalStatus {
						font-size: 18rem;
						font-weight: bold;
						color: #333333;
					}

					.boxStatus {
						font-size: 38rem;
						font-weight: bold;
						color: #68d86a;
					}

					.boxStatusOred {
						font-size: 38rem;
						font-weight: bold;
						color: #fd4238;
					}

					.boxStatusOBack {
						font-size: 38rem;
						font-weight: bold;
						color: #0d94ff;
					}
				}
			}

			.operation1 {
				.w(232);
				height: 100%;
				background: rgba(0, 43, 102, 0.04);
				display: flex;
				justify-content: center;
				align-items: center;

				.ovall {
					.h(127);
					.w(89);
					display: grid;
					text-align: center;

					.totalStatus {
						font-size: 18rem;
						font-weight: bold;
						color: #333333;
					}

					.boxStatus1 {
						// margin: auto;
						font-size: 18rem;

						.ax {
							width: 90%;
							margin: auto;
							display: flex;
							line-height: 28px;
							// justify-content: space-between;
							align-items: center;
							white-space: nowrap;
							font-size: 18rem;

							// p {
							//     font-size: 18rem;
							//     color: #333333;
							//     // white-space: nowrap
							// }

							.ax-2 {
								// display: flex;
								// justify-content: space-between;
								font-weight: 400;
								color: #0d94ff;
								font-size: 18rem;
								margin-right: 5rem
							}
						}
					}
				}
			}
		}

		.realRight {
			.w(724);
			.h(342);
			background: #ffffff;
			box-shadow: 0px 0px 16px 0px rgba(0, 43, 102, 0.04);
			padding: 24rem;

			.foune-1 {
				display: flex;
				justify-content: space-between;

				// background-color: red;
				.tit-1 {
					display: flex;
					.w(170);
					justify-content: space-between;
					.h(69);
					font-size: 18rem;
					font-weight: 400;
					color: #333333;
				}
			}

			// .foune-2::-webkit-scrollbar {
			// width: 1px !important;
			// }
			.foune-2 {
				width: 100%;
				height: 80%;
				overflow-y: scroll;

				.oLi {
					width: 50%;
					height: 11%;
					background-color: #fff;
					// display: flex;
					border-top: rgba(0, 0, 0, 0.06) 1px solid;
					// align-items: center;
					float: left;

					.oli-Div {
						width: 100%;
						height: 100%;
						font-size: 18rem;
						display: flex;
						justify-content: space-between;
						padding-right: 35%;
					}
				}
			}
		}

		.tit {
			font-size: 18rem;
			color: #333333;
			font-weight: bold;
			position: relative;
		}
	}

	.real-data {
		background-color: #ffffff;
		padding: 24rem;
		.h(342);

		.total-data {
			margin-top: 23rem;
			background: rgba(0, 43, 102, 0.04);
			border-radius: 4px;
			// padding-left: 8rem;
			line-height: 36rem;

			font-size: 18rem;
			font-weight: 400;
			color: #333333;

			.total-item {
				background-color: #fff;
				height: 100%;
			}

			.total-data-close {
				margin-left: 24rem;
				color: #fd4238;
				font-weight: bold;
			}

			.total-data-open {
				margin-left: 24rem;
				color: #68d86a;
				font-weight: bold;
			}
		}

		.PowerQuality-none {
			.w(280) !important;

			.val {
				.w(145) !important;
			}

			.key {
				width: auto !important;
				margin-left: 25rem;
				margin-right: 32rem;
			}
		}

		.data {
			.w(395);

			.details {
				.h(132);
				justify-content: space-between;
				margin-top: 23rem;

				.row {
					margin-bottom: 18rem;
				}

				.active {
					span {
						color: #fd4238;
					}
				}

				.key,
				.val {
					font-size: 14rem;
					color: #333333;
					font-weight: 400;
				}

				.key {
					.w(120);
					/*margin-right: 4rem;*/
				}

				.val {
					color: #0d94ff;
					.w(263);

					span {
						display: inline-block;
						width: 25%;
					}
				}
			}
		}

		.tit {
			font-size: 18rem;
			color: #333333;
			font-weight: bold;
			position: relative;

			.location-right {
				.w(492);
				.h(236);
				position: absolute;
				right: 69rem;
				background-color: red;
				padding: 36rem 0 0 38rem;
				background: rgba(0, 43, 102, 0.04);

				.location-and {
					display: flex;
					align-items: center;
					height: 34rem;

					.location-img {
						width: 34rem;
						height: 34rem;
						margin-right: 5px;
					}

					img {
						width: 34rem;
						height: 34rem;
					}
				}

				.location-title {
					// font-size: 24px;

					font-size: 28rem;
					font-weight: bold;
					color: #68d86a;

					line-height: 30px;
				}

				.location-orag {
					font-size: 28rem;
					font-weight: bold;
					color: #f5aa00;

					line-height: 30px;
				}

				.location-item {
					margin-top: 35rem;
					.w(420);
					height: 63px;
					font-size: 16rem;
					font-weight: 400;
					color: #999999;
					word-wrap: break-word;
					word-break: break-all;
					overflow: hidden;
					/*这个参数根据需求来决定要不要*/
				}
			}
		}

		.name {
			font-size: 18rem;
			color: #333333;
			font-weight: bold;
			border-bottom: 1px solid rgba(0, 0, 0, 0.15);
			padding-bottom: 8rem;
			margin-top: 20rem;
			padding-left: 17rem;
		}
	}

	.Loopst {
		width: 475rem;
	}

	.breaker {
		display: flex;
		width: 100%;
		height: 100%;
		// background-color: rgba(0, 43, 102, 0.04);
		padding-left: 8rem;

		span {
			font-size: 18rem;
			font-weight: bold;
		}

		.k {
			color: #333333;
			margin-right: 24rem;
		}

		.v {
			color: red;
		}

		.Handcart {
			color: #0d94ff;
		}

		.sate {
			padding-left: 325rem;
		}
	}

	.ored {
		margin-left: 24rem;
		color: #fd4238;
		font-weight: bold;
	}

	.oglad {
		margin-left: 24rem;
		color: #68d86a;
		font-weight: bold;
	}

	.obalck {
		color: #0d94ff;
		font-weight: bold;
	}
</style>
